import { Switch, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const SwitchCardLabel = styled(Typography)({
  fontSize: '12px',
  fontWeight: '500',
  fontFamily: 'Poppins',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: '#414046',
});

export const SwitchCardSwitch = styled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#0A7ABE',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#AFD5FF',
  },
});
